import { Component, Input } from '@angular/core';

export type KpiChangeTone = 'good' | 'bad' | 'warn';

const TONE_COLOR: Record<KpiChangeTone, string> = {
    good: '#00a63e',
    bad: '#e7000b',
    warn: '#f54900',
};

const TONE_ICON: Record<KpiChangeTone, string> = {
    good: 'assets/img/icons/intel-trend-green.svg',
    bad: 'assets/img/icons/intel-trend-red.svg',
    warn: 'assets/img/icons/intel-trend-orange.svg',
};

/** Tarjeta de KPI: icono + valor + "vs periodo anterior" + mini-gráfica opcional.
 * El "tono" del cambio (good/bad/warn) lo decide quien usa la tarjeta según el
 * significado del KPI (ej. más km recorridos es bueno, más gasto es malo) —
 * nunca se infiere del signo del porcentaje, como confirma el diseño de Figma
 * (ahí las 4 tarjetas muestran deltas positivos pero coloreados distinto:
 * verde/rojo/rojo/naranja). */
@Component({
    selector: 'app-kpi-card',
    templateUrl: './kpi-card.component.html',
    styleUrls: ['./kpi-card.component.css']
})
export class KpiCardComponent {
    @Input() icon = '';
    @Input() iconBg = '#f3e8ff';
    @Input() label = '';
    @Input() value = '';
    @Input() subLabel = '';
    @Input() changePct: number | null = null;
    @Input() changeTone: KpiChangeTone = 'good';
    @Input() changeLabel = 'vs periodo anterior';
    @Input() trend: number[] = [];
    @Input() trendColor = '#7c3aed';

    get changeColor(): string {
        return TONE_COLOR[this.changeTone];
    }

    get changeIcon(): string {
        return TONE_ICON[this.changeTone];
    }
}
